import React from 'react';

const AccessDenied = () => {
    return (
        <div className="container-fluid d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
            <div className="text-center p-4 border border-danger rounded shadow">
                <h1 className="text-danger">Access Denied</h1>
                <p className="lead">You do not have permission to view this page.</p>
            </div>
        </div>
    );
};

export default AccessDenied;
